export default  (msg = '', type = 'success') => {
    const toast = window.Swal.mixin({ toast: true, position: 'top-right', showConfirmButton: false, timer: 5000,  showCloseButton: true  });
    toast.fire({ icon: type, title: msg, padding: '10px 20px' });
};
